<style scoped>
@screen md {
    .row {
        max-width: 15rem;
        border-bottom-width: 1px;
        border-color: theme('colors.primary.default');
    }
    .row-last {
        border-bottom-width: 0;
    }
}

/* Tooltip */
.radiobox {
    position: relative;
}

.radiobox:hover .tooltiptext {
    visibility: visible;
}

@screen md {
    .radiobox .tooltiptext {
        font-size: 0.75rem;
        visibility: hidden;
        width: 300px;
        color: black;
        background-color: #fff2cc;
        border-color: #ffbf00;
        border-width: 1px;
        text-align: center;
        padding: 5px 0;

        position: absolute;
        z-index: 1;
        top: 0%;
        right: 90%;

        @apply font-normal;
    }
}

@media (max-width: theme('screens.md')) {
    .radiobox .tooltiptext {
        font-size: 0.75rem;
        visibility: hidden;
        width: 160%;
        color: black;
        background-color: #fff2cc;
        border-color: #ffbf00;
        border-width: 1px;
        text-align: center;
        padding: 5px 0;

        position: absolute;
        z-index: 1;
        top: 100%;
        right: -30%;

        @apply font-normal;
    }
}
</style>

<template>
    <div class="flex flex-wrap md:-mx-8 w-full">
        <div class="flex justify-center m-3 w-full" v-if="status === 'loading'">
            <spinner />
        </div>

        <div class="flex flex-row flex-wrap justify-center w-full">
            <div
                v-for="(p, pi) in paymentOptions"
                :key="pi"
                class="radiobox w-32 flex sm:w-48 md:w-full sm:max-w-xs md:justify-center"
                :class="{ 'pr-1': pi % 2 === 0 }"
            >
                <radiobox
                    :value="selectedPayment"
                    @input="
                        v => {
                            selectedPayment = v;
                            $emit('paymentSelected', v);
                        }
                    "
                    :checkedValue="p"
                    class=" row w-full"
                    :class="{
                        'row-last': pi === paymentOptions.length - 1
                    }"
                    :disabled="isDisalbedPaymentMethod(p)"
                >
                    <div
                        class="w-full flex flex-col-reverse md:flex-row items-center justify-between px-2 text-sm sm:text-base "
                    >
                        <div>
                            {{ paymentName(p) }}
                        </div>
                        <img class="w-12 sm:w-16" :src="paymentImg(p)" />
                    </div>
                </radiobox>
                <span v-if="isDisalbedPaymentMethod(p)" class="tooltiptext">
                    以下產品不接受此付款方式:
                    <div
                        v-for="(m, mi) in disabledPaymentMethodProducts(p)
                            .messages"
                        :key="mi"
                    >
                        {{ m }}
                    </div>
                </span>
            </div>
        </div>
    </div>
</template>

<script>
import spinner from '@/components/spinner.vue';
import radiobox from './radiobox.vue';
import { paymentInfos } from './paymentMethodInfo.js';

export default {
    components: { spinner, radiobox },
    props: {
        status: { default: undefined },
        hiddenProviders: { type: Array, default: () => [] },
        disabledProviders: { type: Array, default: () => [] }
    },
    computed: {
        companyPaymentMethodList() {
            if (
                this.$store.state.companyPaymentMethodList &&
                this.$store.state.companyPaymentMethodList.length
            ) {
                return this.$store.state.companyPaymentMethodList;
            }

            return [];
        },
        paymentOptions() {
            return this.companyPaymentMethodList.filter(
                p => !this.hiddenProviders.includes(p.pymtSrvcPrvdId)
            );
        },
        isDisalbedPaymentMethod() {
            return p =>
                this.disabledProviders.some(
                    pm =>
                        pm.pymtSrvcPrvdId === p.pymtSrvcPrvdId &&
                        pm.pymtMthdId === p.pymtMthdId
                );
        },
        disabledPaymentMethodProducts() {
            return p =>
                this.disabledProviders.find(
                    pm =>
                        pm.pymtSrvcPrvdId === p.pymtSrvcPrvdId &&
                        pm.pymtMthdId === p.pymtMthdId
                );
        }
    },
    data() {
        return {
            selectedPayment: undefined,
            showPaymentName: false
        };
    },
    methods: {
        paymentImg(paymentOption) {
            return paymentInfos.find(
                pi =>
                    pi.pymtSrvcPrvdId === paymentOption.pymtSrvcPrvdId &&
                    pi.pymtMthdId === paymentOption.pymtMthdId
            ).img;
        },
        paymentName(paymentOption) {
            return this.$t(
                'order.payment.method.' +
                    paymentOption.pymtSrvcPrvdId +
                    '.' +
                    paymentOption.pymtMthdId
            );
        }
    }
};
</script>
